module.exports = __webpack_public_path__ + "static/media/36.84cb7a8c.mp3";